import { useEffect, useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import fetchProducts from "pages/Catalog/helpers/fetchProducts";
import ListState from "pages/Catalog/models/state.interface";
import ProductItem from "pages/Catalog/models/item.interface";
import { useSelector } from "react-redux";

export default (tags: string[], query?: string): any => {
    const navigate = useNavigate();
    const location = useLocation();
    const language = useSelector((state: any) => state.page.languageId);

    const categoriesObj: Record<string, any> = useSelector<any, Record<string, any>>((state: any) => state.catalog?.categories);

    const [categories, setCategories] = useState<any[]>();
    const [products, setProducts] = useState<any[]>();
    const [viewState, setViewState] = useState<string>("LOADING");

    useEffect(() => {
        const getProducts = async () => {
            const response = await fetchProducts(location.pathname, language);
            setProducts(response);
        };

        getProducts();
    }, []);

    useEffect(() => {
        let isComponentMounted = true;

        const getProducts = async () => {
            let result: ProductItem[] = [];

            if (products && products.length > 0) {
                const eligibleProducts = products.filter((product: any) => {
                    const productTags: string[] = [];

                    // Main category
                    productTags.push(product.mainCategory);

                    // Sub categories
                    if (product.subCategories && product.subCategories.length > 0) {
                        product.subCategories.split(",").forEach((subCategory: string) => {
                            subCategory = subCategory.trim();
                            productTags.push(subCategory);
                        });
                    }

                    // Images
                    if (product.mediaCloudA4Skilt1) {
                        productTags.push("MATERIAL_SIGN");
                    } else if (product.mediaCloudA4Skilt2) {
                        productTags.push("MATERIAL_SIGN");
                    }

                    if (product.mediaCloudImage1) {
                        productTags.push("MATERIAL_PICTURE");
                    } else if (product.mediaCloudImage2) {
                        productTags.push("MATERIAL_PICTURE");
                    } else if (product.mediaCloudImage3) {
                        productTags.push("MATERIAL_PICTURE");
                    } else if (product.mediaCloudImage4) {
                        productTags.push("MATERIAL_PICTURE");
                    }

                    // Query
                    const formattedQuery = JSON.parse(JSON.stringify(query ?? ""))
                        ?.toLowerCase()
                        .trim();
                    let showByQuery = false;
                    if (formattedQuery && formattedQuery.length > 0) {
                        // SKU
                        if (product.sku.indexOf(formattedQuery) > -1) {
                            showByQuery = true;
                        }

                        // Name
                        if (product.itemName.toLowerCase().indexOf(formattedQuery) > -1) {
                            showByQuery = true;
                        }
                    } else {
                        showByQuery = true;
                    }

                    // Tags
                    let showByTags = false;
                    if (tags && tags.length > 0) {
                        showByTags = tags.every((x) => (productTags && productTags.length > 0 ? productTags.includes(x) : false));
                    } else {
                        showByTags = true;
                    }

                    return showByQuery && showByTags;
                });

                // TODO: Map inside categories
                result = eligibleProducts;
            }

            if (isComponentMounted) {
                return result;
            }
        };

        setViewState("LOADING");

        if (categoriesObj) {
            getProducts()
                .then((result) => {
                    if (result && result.length > 0) {
                        // CATEGORIES MAPPING //
                        const categoriesArr = [];

                        // Main Categories
                        for (const key in categoriesObj) {
                            const category = categoriesObj[key];

                            const eligibleProducts = result.filter((x) => {
                                let includeProduct = false;

                                if (x.mainCategory !== category.result.category.id) {
                                    return false;
                                }

                                if (x.mediaCloudImage1) {
                                    includeProduct = true;
                                } else if (x.mediaCloudImage2) {
                                    includeProduct = true;
                                } else if (x.mediaCloudImage3) {
                                    includeProduct = true;
                                } else if (x.mediaCloudImage4) {
                                    includeProduct = true;
                                } else if (x.mediaCloudA4Skilt1) {
                                    includeProduct = true;
                                } else if (x.mediaCloudA4Skilt2) {
                                    includeProduct = true;
                                }

                                return includeProduct;
                            });

                            if (eligibleProducts && eligibleProducts.length > 0) {
                                categoriesArr.push({
                                    url: key,
                                    category: category.result.category,
                                    products: eligibleProducts,
                                });
                            }
                        }

                        if (categoriesArr && categoriesArr.length > 0) {
                            setCategories(categoriesArr);
                            setViewState("LOADED");
                        } else {
                            setViewState("EMPTY");
                        }
                    } else {
                        setViewState("EMPTY");
                    }
                })
                .catch(() => {
                    setViewState("ERROR");
                });
        }

        return () => {
            isComponentMounted = false;
        };
    }, [tags, query, categoriesObj, products]);

    return [categories, viewState];
};
